"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = require("immutable");
var core_1 = __importDefault(require("@gin-betting/core"));
var utils_1 = require("../utils");
var replaceBetslipBetIdInBetslipOddId = core_1.default.utils.replaceBetslipBetIdInBetslipOddId;
function handleRehydrate(state, rehydrationState) {
    if (!rehydrationState)
        return state;
    var betslipBetsFromLocalStorage = rehydrationState.betslipBets, betslipOddsFromLocalStorage = rehydrationState.betslipOdds;
    var initialBetslipBetFromLocalStorage = utils_1.getInitialBetslipBet({
        betslipBets: betslipBetsFromLocalStorage,
        betslipOdds: betslipOddsFromLocalStorage,
    });
    if (!initialBetslipBetFromLocalStorage)
        return state;
    var betslipOdds = state.betslipOdds, betslipBets = state.betslipBets;
    var initialBetslipBet = utils_1.getInitialBetslipBet({
        betslipBets: betslipBets,
        betslipOdds: betslipOdds,
    });
    var adoptiveBetslipBet = initialBetslipBet || utils_1.createBetslipBet();
    var betslipOddIds = adoptiveBetslipBet.betslipOddIds;
    var modeFromLocalStorage = initialBetslipBetFromLocalStorage.mode, betslipOddIdsFromLocalStorage = initialBetslipBetFromLocalStorage.betslipOddIds;
    var adoptiveBetslipOdds = betslipOddIdsFromLocalStorage.reduce(function (acc, betslipOddId) {
        var betslipOdd = betslipOddsFromLocalStorage[betslipOddId];
        if (!betslipOdd)
            return acc;
        var newBetslipOddId = replaceBetslipBetIdInBetslipOddId({
            betslipOddId: betslipOddId,
            newBetslipBetId: adoptiveBetslipBet.id,
        });
        if (betslipOddIds.has(newBetslipOddId))
            return acc;
        var newBetslipOdd = __assign(__assign({}, betslipOdd), { id: newBetslipOddId });
        return acc.set(newBetslipOdd.id, newBetslipOdd);
    }, immutable_1.OrderedMap());
    var nextBetslipOddIds = betslipOddIds.merge(adoptiveBetslipOdds.keySeq());
    var nextMode = utils_1.getNextModeBySize({
        mode: modeFromLocalStorage,
        nextBetslipOddIds: nextBetslipOddIds,
    });
    var nextBetslipBet = __assign(__assign({}, initialBetslipBetFromLocalStorage), { id: adoptiveBetslipBet.id, betslipOddIds: nextBetslipOddIds, mode: nextMode });
    var nextBetslipBets = betslipBets.set(nextBetslipBet.id, nextBetslipBet);
    var nextBetslipOdds = betslipOdds.merge(adoptiveBetslipOdds);
    return state
        .set('betslipOdds', nextBetslipOdds)
        .set('betslipBets', nextBetslipBets);
}
exports.default = handleRehydrate;
//# sourceMappingURL=handleRehydrate.js.map